// Production-variant analog of `branded-text-element-mixin.js`. Carries the
// same `optionBundles` + branding type so the resolver produces identical
// values for the same persisted options, but composes `TextElementRenderMixin`
// instead of the heavy editor `TextElementMixin`. No iRichText, no link-modal,
// no inline-edit handlers — just the render-critical computeds.

import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import BrandedTextOptions from "%/dynamic-component-editor/bundles/branded-text-options";
import TextOptions from "%/dynamic-component-editor/bundles/text-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import {
  TextElementRenderMixin,
} from "%/dynamic-component-editor/standard-elements/text-element/text-element-render-mixin";
import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";
import EffectsOptions from "%/dynamic-component-editor/bundles/effects-options";
import AnimationEffectsOptions from "%/dynamic-component-editor/bundles/animation-effects-options";
import BorderOptions from "%/dynamic-component-editor/bundles/border-options";
import ClickAction from "%/dynamic-component-editor/options/click-action";
import TypographyBranding from "%/dynamic-component-editor/classes/branding/typography-branding";

export const BrandedTextElementRenderMixin = {
  mixins: [DynamicElementMixin, TextElementRenderMixin],
  brandingType: TypographyBranding,
  optionBundles: [
    AppearanceOptions,
    AnimationEffectsOptions,
    new LayoutWidthHeightOptions({}, {
      "max-height": true,
      "min-height": true,
    }),
    BrandedTextOptions,
    BasicTextOptions,
    TextOptions,
    new BackgroundOptions({}, {
      "background-image": true,
      "background-gradient": true,
    }),
    SpacingOptions,
    EffectsOptions,
    BorderOptions,
  ],
  options: [
    ClickAction,
  ],
};
